import React from 'react';
import { Icons } from './Icon';

export interface GlobalDashboardDropOverlayProps {
    active: boolean;
}

export const GlobalDashboardDropOverlay: React.FC<GlobalDashboardDropOverlayProps> = ({ active }) => {
    if (!active) return null;

    return (
        <div className="global-drop-overlay">
            <div className="global-drop-zone">
                <div className="global-drop-zone-icon">
                    <Icons.Download size={32} style={{ color: 'white' }} />
                </div>
                <h3>DROP TO START</h3>
                <p>Folder or files. Auto-classified. New project created on release.</p>
                <div className="global-drop-hints">
                    <span className="global-drop-hint"><Icons.Image size={13} /> Photos</span>
                    <span className="global-drop-hint"><Icons.Video size={13} /> Videos</span>
                    <span className="global-drop-hint"><Icons.FileText size={13} /> Documents</span>
                    <span className="global-drop-hint"><Icons.Mail size={13} /> Emails</span>
                    <span className="global-drop-hint"><Icons.AlignLeft size={13} /> Text</span>
                </div>
            </div>
        </div>
    );
};

export default GlobalDashboardDropOverlay;
